import { render } from "./PensionOptions.vue?vue&type=template&id=67ff484a&scoped=true"
import script from "./PensionOptions.vue?vue&type=script&lang=js"
export * from "./PensionOptions.vue?vue&type=script&lang=js"

import "./PensionOptions.vue?vue&type=style&index=0&id=67ff484a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67ff484a"]])

export default __exports__